var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29304 11.2929C6.90252 11.6834 6.90252 12.3166 7.29304 12.7071L15.293 20.7071C15.6836 21.0976 16.3167 21.0976 16.7073 20.7071C17.0978 20.3166 17.0978 19.6834 16.7073 19.2929L9.41436 12L16.7073 4.70711C17.0978 4.31658 17.0978 3.68342 16.7073 3.29289C16.3167 2.90237 15.6836 2.90237 15.293 3.29289L7.29304 11.2929Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/Chevron-Left.c9f19134939bb2f215567a0302e3d6d7.svg";
export { ForwardRef as ReactComponent };